import { jsx as m } from "react/jsx-runtime";
import { RangeSlider as o } from "flowbite-react";
import { forwardRef as i } from "react";
import { rangeSliderTheme as a } from "./theme.js";
const t = i(
  (r, e) => /* @__PURE__ */ m(
    o,
    {
      ref: e,
      theme: a,
      ...r
    }
  )
);
t.displayName = "RangeSlider";
export {
  t as RangeSlider
};
